import { ARReportLayout } from './layouts';
import { ARDashboardView } from './components/ARDashboardView';

export function ARDashboardPage() {
  return (
    <ARReportLayout>
      <ARDashboardView />
    </ARReportLayout>
  );
}

